define('Components/PageHeaderWidget/js/views/EngagementsHeaderWidgetInstanceView',['jquery','Components/PageHeaderWidget/js/views/PageHeaderWidgetInstanceView','app','template!Components/PageHeaderWidget/templates/engagements'],
    function($,PageHeaderWidgetInstanceView,app,template){
    return PageHeaderWidgetInstanceView.extend({
        setup:function(){
        },
        getTemplate:function(){
            return template;
        },
        afterRender:function(){
            var self = this;
        }
    })
});
